import React from 'react';

const DowngradePlanContent = ({ planId }) => {
	if (planId === 285278) {
		return (
			<>
				<h1 className="primary-header">We found a better plan for you!</h1>{' '}
				<p>
					Good news! Based on your needs, you qualify for one of our e-commerce
					plans with our most competitive rates.
				</p>
			</>
		);
	} else if (planId === 278) {
		return (
			<>
				<h1 className="primary-header">We found a better plan for you!</h1>{' '}
				<p>
					Good news! Based on your e-commerce needs, you qualify for our{' '}
					<b>E-commerce Pro Plan</b> with our most competitive postage rates.
				</p>
			</>
		);
	} else if (planId === 248) {
		return (
			<>
				<h1 className="primary-header">We have a special offer for you!</h1>{' '}
				<p>Good news! You're eligible for our FREE Basic Shipping Plan!</p>
			</>
		);
	} else if (planId === 182 || planId === 100) {
		return (
			<>
				<h1 className="primary-header">We have a special offer for you!</h1>{' '}
				<p>Good news! You're eligible for our Basic plan!</p>
			</>
		);
	}

	return null;
};

export default DowngradePlanContent;
